import React from "react";
import { Button, Modal } from "react-bootstrap";
// import { render } from '@testing-library/react';

const ConfirmationAlert = (props) => {
  // render()
  // {

  return (
    <Modal
      show={props.show}
      animation={props.isAnimate}
      aria-labelledby="example-modal-sizes-title-sm"
    >
      <Modal.Header>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.message}</Modal.Body>
      <Modal.Footer>
        {props.buttons.length > 0 &&
          props.buttons.map((item) => (
            <Button
              className={item.cssclass}
              onClick={item.onClick}
              key={item.label}
            >
              {item.label}
            </Button>
          ))}
      </Modal.Footer>
    </Modal>
  );
  // }
};
export default ConfirmationAlert;
